let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("SZjgt")).then(() => parcelRequire('dsqvM'));